/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyStocks } from 'app/entities/pharmacy-stock/pharmacy-stock.reducer';
import { getEntities as getPharmacyBills } from 'app/entities/pharmacy-bill/pharmacy-bill.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getPaymentSchemes } from 'app/entities/payment-scheme/payment-scheme.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-bill-item.reducer';

export const PharmacyBillItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyStocks = useAppSelector(state => state.pharmacyStock.entities);
  const pharmacyBills = useAppSelector(state => state.pharmacyBill.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const paymentSchemes = useAppSelector(state => state.paymentScheme.entities);
  const pharmacyBillItemEntity = useAppSelector(state => state.pharmacyBillItem.entity);
  const loading = useAppSelector(state => state.pharmacyBillItem.loading);
  const updating = useAppSelector(state => state.pharmacyBillItem.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyBillItem.updateSuccess);

  const handleClose = () => {
    navigate(`/pharmacy-bill-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyStocks({}));
    dispatch(getPharmacyBills({}));
    dispatch(getClinicalDictionaries({}));
    dispatch(getPaymentSchemes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.chargedMrp !== undefined && typeof values.chargedMrp !== 'number') {
      values.chargedMrp = Number(values.chargedMrp);
    }
    if (values.qty !== undefined && typeof values.qty !== 'number') {
      values.qty = Number(values.qty);
    }
    if (values.manufacDate !== undefined && typeof values.manufacDate !== 'number') {
      values.manufacDate = Number(values.manufacDate);
    }
    if (values.expDate !== undefined && typeof values.expDate !== 'number') {
      values.expDate = Number(values.expDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    if (values.paidAmount !== undefined && typeof values.paidAmount !== 'number') {
      values.paidAmount = Number(values.paidAmount);
    }
    if (values.cessAmount !== undefined && typeof values.cessAmount !== 'number') {
      values.cessAmount = Number(values.cessAmount);
    }
    if (values.freeQty !== undefined && typeof values.freeQty !== 'number') {
      values.freeQty = Number(values.freeQty);
    }

    const entity = {
      ...pharmacyBillItemEntity,
      ...values,
      pharmacyStock: pharmacyStocks.find(it => it.id.toString() === values.pharmacyStock?.toString()),
      pharmacyBill: pharmacyBills.find(it => it.id.toString() === values.pharmacyBill?.toString()),
      uqcType: clinicalDictionaries.find(it => it.id.toString() === values.uqcType?.toString()),
      scheme: paymentSchemes.find(it => it.id.toString() === values.scheme?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...pharmacyBillItemEntity,
          pharmacyStock: pharmacyBillItemEntity?.pharmacyStock?.id,
          pharmacyBill: pharmacyBillItemEntity?.pharmacyBill?.id,
          uqcType: pharmacyBillItemEntity?.uqcType?.id,
          scheme: pharmacyBillItemEntity?.scheme?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyBillItem.home.createOrEditLabel" data-cy="PharmacyBillItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.home.createOrEditLabel">Create or edit a PharmacyBillItem</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-bill-item-id"
                  label={translate('tinyMedicRestApp.pharmacyBillItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillItem.chargedMrp')}
                id="pharmacy-bill-item-chargedMrp"
                name="chargedMrp"
                data-cy="chargedMrp"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillItem.qty')}
                id="pharmacy-bill-item-qty"
                name="qty"
                data-cy="qty"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillItem.manufacDate')}
                id="pharmacy-bill-item-manufacDate"
                name="manufacDate"
                data-cy="manufacDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillItem.expDate')}
                id="pharmacy-bill-item-expDate"
                name="expDate"
                data-cy="expDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillItem.active')}
                id="pharmacy-bill-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillItem.cursor')}
                id="pharmacy-bill-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillItem.timestampentry')}
                id="pharmacy-bill-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillItem.microSec')}
                id="pharmacy-bill-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillItem.lastupdated')}
                id="pharmacy-bill-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillItem.discount')}
                id="pharmacy-bill-item-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillItem.paidAmount')}
                id="pharmacy-bill-item-paidAmount"
                name="paidAmount"
                data-cy="paidAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillItem.taxCode')}
                id="pharmacy-bill-item-taxCode"
                name="taxCode"
                data-cy="taxCode"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillItem.cessAmount')}
                id="pharmacy-bill-item-cessAmount"
                name="cessAmount"
                data-cy="cessAmount"
                type="text"
              />
              <UncontrolledTooltip target="cessAmountLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.help.cessAmount" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillItem.exempted')}
                id="pharmacy-bill-item-exempted"
                name="exempted"
                data-cy="exempted"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="exemptedLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.help.exempted" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyBillItem.freeQty')}
                id="pharmacy-bill-item-freeQty"
                name="freeQty"
                data-cy="freeQty"
                type="text"
              />
              <UncontrolledTooltip target="freeQtyLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacyBillItem.help.freeQty" />
              </UncontrolledTooltip>
              <ValidatedField
                id="pharmacy-bill-item-pharmacyStock"
                name="pharmacyStock"
                data-cy="pharmacyStock"
                label={translate('tinyMedicRestApp.pharmacyBillItem.pharmacyStock')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyStocks
                  ? pharmacyStocks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-bill-item-pharmacyBill"
                name="pharmacyBill"
                data-cy="pharmacyBill"
                label={translate('tinyMedicRestApp.pharmacyBillItem.pharmacyBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyBills
                  ? pharmacyBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-bill-item-uqcType"
                name="uqcType"
                data-cy="uqcType"
                label={translate('tinyMedicRestApp.pharmacyBillItem.uqcType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-bill-item-scheme"
                name="scheme"
                data-cy="scheme"
                label={translate('tinyMedicRestApp.pharmacyBillItem.scheme')}
                type="select"
              >
                <option value="" key="0" />
                {paymentSchemes
                  ? paymentSchemes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-bill-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyBillItemUpdate;
